module.exports = __webpack_public_path__ + "static/media/teamwork.61592ec6.png";